require('@js/slick.min.js')

import '@scss/pages/home.scss';
import "../sass/library/slick";

(function ($) {
    document.addEventListener('DOMContentLoaded', () => {
        $("#menu-main-menu .active a").addClass('active');

        $(window).scroll(function () {

            let position = [];

            $('.section').each(function () {
                position.push(Math.abs($(this).position().top) + 345)
            })
            let value = $(this).scrollTop() + $('#menu-main-menu').height();

            let followPosition = Math.abs($('#follow').position().top);
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

                $.each(position, function (i) {
                    if (viewportBottom >= followPosition) {
                        $('.active').removeClass('active');
                        $("#menu-main-menu li a").eq(4).addClass('active');
                        return false;
                    } else if (this > value) {
                    $('.active').removeClass('active');
                    $("#menu-main-menu li a").eq(i).addClass('active');
                    return false;
                }
            })
        });

        const expression = /(Mac|iPhone|iPod|iPad)/i;
        var button = document.getElementById('play_button');
        if (expression.test(navigator.platform)) {
            button.href = 'https://apps.apple.com/ua/app/scatter-slots-slot-machines/id944158857?l=ru';
        } else {
            button.href = 'https://play.google.com/store/apps/details?id=com.murka.scatterslots&hl=en';
        }
/////////////////////////////////////////////////////////////
        function watchForHover() {
            // lastTouchTime is used for ignoring emulated mousemove events
            let lastTouchTime = 0

            function enableHover() {
                if (new Date() - lastTouchTime < 500) return
                document.body.classList.add('hasHover')
            }

            function disableHover() {
                document.body.classList.remove('hasHover')
            }

            function updateLastTouchTime() {
                lastTouchTime = new Date()
            }

            document.addEventListener('touchstart', updateLastTouchTime, true)
            document.addEventListener('touchstart', disableHover, true)
            document.addEventListener('mousemove', enableHover, true)

            enableHover()
        }

        watchForHover()
        ////////////////////////////////////////////////
        $(document).ready(function () {

            $('.hero-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                infinite: true,
                asNavFor: '.slider-nav',
                prevArrow: "<div class='slick-prev' ></div>",
                nextArrow: "<div class='slick-next' ></div>",
            });

            setTimeout(function () {
                $('.slider-nav')
                    .on('init', function (event, slick, direction) {

                            for (let i = 0; i < slick.$slides.length; i++) {
                                let $slide = $(slick.$slides[i]);
                                if ($slide.hasClass('slick-current')) {
                                    $slide.prev().addClass('prevSlide')
                                    $slide.next().addClass('nextSlide')
                                }
                            }
                        }
                    )
                    .slick({
                        cssEase: 'ease-out',
                        slidesToShow: 7,
                        slidesToScroll: 1,
                        asNavFor: '.hero-slider',
                        dots: false,
                        centerMode: true,
                        focusOnSelect: true,
                        arrows: true,
                        centerPadding: "0px",
                        prevArrow: "<div class='slick-prev' ></div>",
                        nextArrow: "<div class='slick-next' ></div>",
                        responsive: [
                            {
                                breakpoint: 1680,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 1,
                                    infinite: true,

                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ],

                    })

                    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        $('.slider-nav .slick-slide').removeClass('prevSlide').removeClass('nextSlide')
                    })
                    .on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        for (let i = 0; i < slick.$slides.length; i++) {
                            let $slide = $(slick.$slides[i]);
                            if ($slide.hasClass('slick-current')) {
                                $slide.prev().addClass('prevSlide')
                                $slide.next().addClass('nextSlide')
                            }
                        }
                    });
            });
        }, 300);
    })
})(jQuery);
